export const DEFAULT_NODE_SORT = [
	{ field: 'position', order: 'asc' },
	{ field: 'start_date', order: 'asc' },
	{ field: 'id', order: 'asc' }
]

const USER_SORT_FIELDS = ['name', 'start_date']

export function buildNodeSort(userSort = []) {
	const activeUserField = userSort.find(entry => USER_SORT_FIELDS.includes(entry.field))
	const defaultSort = DEFAULT_NODE_SORT.filter(entry => entry.field !== activeUserField?.field)

	return activeUserField ? [activeUserField, ...defaultSort] : defaultSort
}

export function nodesPreSort(a, b) {
	const aNeg = a.id < 0
	const bNeg = b.id < 0
	if (aNeg && !bNeg) { return 1 }
	if (!aNeg && bNeg) { return -1 }
	return 0
}

export function isValidNodeSort(sort) {
	const requiredFields = DEFAULT_NODE_SORT.map(entry => entry.field)
	return Array.isArray(sort) && requiredFields.every(field => sort.some(entry => entry.field === field))
}